import { apiRoutes } from 'lib';
import { apiClient } from 'lib/ApiClient';
import { EApiResponseStatus } from 'types/api';
import {
  IChangePAsswordResponse,
  IChangePasswordData,
  IFetchUserResponse,
  IRecoverPasswordData,
  IRecoverPasswordResponse,
  ISignInResponse,
  ISignInUserData,
  ISignUpUserData,
} from 'types/users';

export const AccountRepository = {
  signIn: async (signInUserData: ISignInUserData) => {
    const url = apiRoutes.apiSignInPath();
    const response = (await apiClient.post(url, signInUserData, {})) as ISignInResponse;
    return response;
  },
  signUp: (signUpUserData: ISignUpUserData, referralId?: string) => {
    const url = apiRoutes.apiSignUpPath();
    const options: { queryParams?: Record<string, string> } = {};
    if (referralId !== undefined) {
      options.queryParams = {
        ref: String(referralId),
      };
    }
    return apiClient.post(url, signUpUserData, options);
  },
  fetchUser: async (token: string): Promise<IFetchUserResponse> => {
    const url = apiRoutes.apiFetchUserPath();
    const response = (await apiClient.get(url, {
      Authorization: `Bearer ${token}`,
    })) as IFetchUserResponse;
    return response;
  },
  changePassword: async (
    changePasswordData: IChangePasswordData,
  ): Promise<IChangePAsswordResponse> => {
    console.log(changePasswordData);
    return { status: EApiResponseStatus.FAILURE };
  },
  recoverPassword: async (
    recoverPasswordData: IRecoverPasswordData,
  ): Promise<IRecoverPasswordResponse> => {
    console.log(recoverPasswordData);
    return { status: EApiResponseStatus.SUCCESS };
  },
  verify2FA: async (token: string, code: string): Promise<ISignInResponse> => {
    const url = apiRoutes.api2FAPath();
    const userId = JSON.parse(atob(token.split('.')[1])).id;
    const response = (await apiClient.post(
      url,
      { userId, code },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )) as ISignInResponse;
    return response;
  },
  resend2FA: async (token: string): Promise<ISignInResponse> => {
    const url = apiRoutes.apiResend2FAPath();
    const response = (await apiClient.post(
      url,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )) as ISignInResponse;
    return response;
  },
  get2FATimeout: async (token: string): Promise<{ status: EApiResponseStatus; timeout?: number; error?: string }> => {
    const url = apiRoutes.api2FATimeoutPath();
    const response = await apiClient.get(url, {
      Authorization: `Bearer ${token}`,
    }) as { status: EApiResponseStatus; data?: { timeout: number }; error?: string };

    return {
        status: response.status,
        timeout: response.data?.timeout,
        error: response.error
    };
  },
};
